import { sendVerificationSms } from "../../../actions/login/sendVerificationSms";
import { encode } from "../../../helpers/queryEncryption";
import { auth } from "../../../config-server";
import showToaster from "../../../helpers/toastrMessgaes/showToaster";

async function submit(values, dispatch) {

    if (!values.isAgreePhoneNumberVerification) {
        showToaster({ toasterType: 'error', messageId: 'isAgreePhoneNumberError' });
        return;
    }

    let phoneDialCode, phoneNumber, userType = 1, jwtToken = encode(auth?.jwt?.secret);
    phoneDialCode = values?.phoneDialCode, phoneNumber = values?.phoneNumber;

    values?.phoneNumber && await dispatch(sendVerificationSms({ phoneDialCode, phoneNumber, userType, jwtToken }));
}

export default submit; 